module.exports = class Modal {
    constructor() {
        this.show = false;
        this.callback;
        this.failed;

        this.title = null;
        this.body = null;

        this.type;
    }

    confirm(callback = () => {}, failed = () => {}) {
        this.type = 'yesno',
        this.title = this.title || 'Are you sure?';
        this.body = this.body || 'Are you sure that you want to do that?';

        this.callback = callback;
        this.failed = failed;
        this.show = true;
    }

    ok() {
        this.callback();
        this.show = false;
        this.callback = null;
        this.failed = null;
        this.type = null;
        this.title = null;
        this.body = null;
    }

    cancel() {
        this.failed();
        this.show = false;
        this.callback = null;
        this.failed = null;
        this.type = null;
        this.title = null;
        this.body = null;
    }
}